export default __webpack_public_path__ + "static/media/JCUHSDEC(MedicalandSurgicalunit)SDECguidanceforambulanceclinicians.aaa3671d.jpg";